<div class="modal modal-form container-fluid" [class.modal-hidden]="!showModal">
  <div class="row">
    <div class="modal-content mx-auto p-3"  [class.col-9]="!isAutoSize && !isWideModal" [class.col-11]="isWideModal">
      @if (!hideHeader) {
        <div class="row justify-content-start modal-header m-0 mb-3">
          <div class="col col-12">
            <ng-content select="[form-header]" />
          </div>
        </div>
      }
      <div class="modal-body">
        <ng-content select="[form-body]" />
      </div>
      <hr class="w-100" />
      <div class="d-flex justify-content-end mb-3">
        <div class="d-flex justify-content-start">
          <ng-content select="[left-footer]" />
        </div>
        <div class="d-flex justify-content-center" style="flex:1">
          <ng-content select="[center-footer]" />
        </div>
        <div class="d-flex justify-content-end">
          <ng-content select="[right-footer]" />
          @if (!hideOk) {
            <button pButton pRipple type="submit" [disabled]="disableOk" [pTooltip]="confirmTooltip() ?? ''" [tooltipDisabled]="!confirmTooltip()" [badge]="confirmCount() != null ? '' + confirmCount() : undefined" (click)="ok()">{{confirmButtonText ? confirmButtonText : "OK"}}</button>
          }
          @if (!hideCancel) {
            <p-button type="button" [label]="cancelButtonText ? cancelButtonText : 'Cancel'" severity="secondary"
              [outlined]="true" styleClass="pull-right modal-button" [disabled]="disableCancel" (onClick)="cancel()" />
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-background modal-form-background" [class.modal-hidden]="!showModal"></div>